import { SoundsManagerService } from './SoundsManagerService';

export class SoundManager {
    public static play(url: string) {
        SoundsManagerService.getInstance().play(url);
    }

    public static dispose(url: string) {
        SoundsManagerService.getInstance().dispose(url);
    }
}
